import React from 'react';
import { Navigate, Outlet , useLocation} from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import LandingPageHome from '../components/landing-page/home/home';
import PreLoader from './loaders/preloader';

const ProtectedRoute = ({ children, redirectTo = '/', path }) => {
  const { isAuthenticated, user, loading, token, logout } = useAuth();
  const location=useLocation()


  if(redirectTo=="/logout" && token && user){
        logout() 
        toast.remove()
        toast.success('Logout successfuly!')
        return <Navigate to={'/login'} replace />
  }


  if (loading) {

      return <PreLoader/>;

  }else if(!user && !loading){
      if(location.pathname=="/"){
          return <LandingPageHome/>
      }
      return <Navigate to={'/login'} replace />
  }else{

     return isAuthenticated ? children : <Navigate to={redirectTo} replace />;
  }
};


export default ProtectedRoute;



